import React from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"

const LandingHeader = () => {
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="landing-header-text-wrapper">
        <Block className="landing-header-text">
          <Element type="h2" className="header-text1">{"İşsiz kalma riskine karşı Kart borcunuzu güvence altına alın"}</Element>
          <Element type="p" className="header-text2">{"Kredi Kartı İşsizlik Sigortası ile işsizlik, hastalık, geçici iş göremezlik gibi istenmeyen durumlarda kredi kartı borcunuzu 12.000 TL ‘ye kadar güvenceye alabilirsiniz."}</Element>
        </Block>
      </Block>
      <Image path={"./img/kredikartissizliksigortasi/Kredi-karti-issizlik-basvuru.png"} className="landing-header-img" />
    </Block>
  )
}

export default LandingHeader
